// extracted by mini-css-extract-plugin
module.exports = {"primary-main":"search_primary-main__XuQnJ"};